
export const FRONT_URL = process.env.VUE_APP_FRONT_URL;
export const STORAGE_URL = process.env.VUE_APP_STORAGE_URL;
export const API_URL = process.env.VUE_APP_API_URL;
export const CGU_URL = process.env.VUE_APP_CGU;
export const MAIL_CONTACT = process.env.VUE_APP_MAIL_CONTACT;